"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Dropdown_meta_1 = require("../Dropdown.meta");
var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");
var Label_1 = require("../../Label/Label");
exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Label_1.Label, Dropdown_meta_1.DROPDOWN_CATEGORY_KEY, Dropdown_meta_1.DROPDOWN_COMPONENT_KEY, ['label']);
